import { render } from "./ModalImg.vue?vue&type=template&id=664f2428"
import script from "./ModalImg.vue?vue&type=script&lang=js"
export * from "./ModalImg.vue?vue&type=script&lang=js"

import "./ModalImg.vue?vue&type=style&index=0&id=664f2428&lang=stylus"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__